var React = require('react');

function IconHeatmap (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M11.6 10.4a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2zm0 4.8a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2zM8 11a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zm3.6 8.4a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zM8 15.8a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zm3.6-7.2A.6.6 0 1 0 11 8a.594.594 0 0 0 .6.6zm4.8 1.8a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2zm0-1.8a.6.6 0 1 0-.6-.6.594.594 0 0 0 .6.6zm3.6 7.2a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zm0-4.8a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zm-6-9a12 12 0 1 0 12 12A12 12 0 0 0 14 2zm0 21.6a9.6 9.6 0 1 1 9.6-9.6 9.6 9.6 0 0 1-9.6 9.6zm2.4-4.2a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zm0-4.2a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2z","transform":"translate(-2 -2)"}));
}

IconHeatmap.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconHeatmap;

IconHeatmap.default = IconHeatmap;
